import { useHasPermission } from '@contexts/permissions-provider';
import { InstructorDetailPanel } from '@features/instructors/components/detail-panel/InstructorDetailPanel';
import { useInstructorNavigation } from '@features/instructors/hooks/use-instructor-navigation/useInstructorNavigation';
import * as React from 'react';
import { useParams } from 'react-router-dom';

const InstructorDetailRoute = React.memo((): React.ReactElement => {
  const { instructorId } = useParams<{ instructorId: string }>();
  const canEdit = useHasPermission('InstructorApproval_Edit_Org');
  const { navigateToInstructorsList } = useInstructorNavigation();

  return (
    <>
      {instructorId && (
        <InstructorDetailPanel
          onClose={navigateToInstructorsList}
          instructorId={instructorId}
          canEdit={canEdit}
        />
      )}
    </>
  );
});

InstructorDetailRoute.displayName = 'InstructorDetailRoute';

export { InstructorDetailRoute };
